import { render } from "./container.component.vue?vue&type=template&id=5f1c9d6c&ts=true"
import script from "./container.component.vue?vue&type=script&lang=ts"
export * from "./container.component.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__